import React from 'react';
import { Button } from "react-bootstrap";
import axios from 'axios';

export default class SubmitForm extends React.Component {
    constructor(props) {
        super(props)
    
        this.state = { 
            submitButtonText: 'ส่งข้อมูลสมัครเรียน',
            disableSubmitButton: false 
        }
    }

    disableButton = (status) => {
        if (status) {
            this.setState({ disableSubmitButton: true });
            this.setState({ submitButtonText: 'กำลังส่งข้อมูล...' });
        } else {
            this.setState({ disableSubmitButton: false });
            this.setState({ submitButtonText: 'ส่งข้อมูลสมัครเรียน' });
        }
    }

    submitData = e => {
        let success_msg = 'ได้รับข้อมูลการเรียนของท่านเรียบร้อยแล้ว อาจารย์ประจำสาขา จะดำเนินการติดต่อกลับภายใน 24 ชั่วโมง ขอบคุณค่ะ';
        let regis_form = document.getElementById('regis_form');
        let study_level = document.getElementById('study_level');
        let faculty = document.getElementById('faculty');    
        let department = document.getElementById('department');
        let study_type = document.getElementById('study_type');
        let title = document.querySelector('input[name="title"]:checked');
        let firstname = document.getElementById('firstname');
        let lastname = document.getElementById('lastname');
        let education = document.getElementById('education');
        let grad = document.querySelector('input[name="grad"]:checked');    
        let telephone = document.getElementById('telephone');
        let idline = document.getElementById('idline');
        let email = document.getElementById('email');
        let address = document.getElementById('address');
        let district = document.getElementById('district');
        let khet = document.getElementById('khet');
        let province = document.getElementById('province');
        let postcode = document.getElementById('postcode');
        let borrow = document.getElementById('borrow');
        let friend = document.getElementById('friend');
        let friend_telephone = document.getElementById('friend_telephone');                
    
        if (title == null || title.value === '') {
            alert('กรุณาเลือกคำนำหน้าชื่อ');
            return;
        }
    
        if (firstname.value === '') {
            alert('กรุณากรอกชื่อ');
            firstname.focus();
            return;
        }
    
        if (lastname.value === '') {
            alert('กรุณากรอกนามสกุล');
            lastname.focus();
            return;
        }
    
        if (education.value === '') {
            alert('กรุณากรอกสถานศึกษา');
            education.focus();
            return;
        }
    
        if (grad == null || grad.value === '') {
            alert('กรุณาเลือกระดับการจบการศึกษา');
            return;
        }    
    
        if (telephone.value === '') {
            alert('กรุณากรอกสถานศึกษา');
            telephone.focus();
            return;
        }
    
        e.preventDefault();
        this.disableButton(true);

        let data = { level_id: study_level.value, faculty_id: faculty.value, department_id: department.value,
            study_type_id: study_type.value, titlename: title.value, firstname: firstname.value, lastname: lastname.value,
            school: education.value, graduate: grad.value, email: email.value, telephone: telephone.value,
            lineid: idline.value, address: address.value, district: district.value, khet: khet.value, 
            province: province.value, postcode: postcode.value, borrow: borrow.value, friend: friend.value,
            friend_telephone: friend_telephone.value
        };
        console.log(data);
        axios.post(`${process.env.REACT_APP_ENDPOINT}/regisonline/addstudent`, data, {
            headers: {
                'Content-Type': 'application/json',
                'authtoken': `${process.env.REACT_APP_AUTH_KEY}`
            }
        })
        .then(resp => { 
            const { return_code, return_message } = resp.data
            if (return_code === '0000') {
                alert(success_msg);
                regis_form.reset();
            } else {
                console.log(return_message);
            }
            this.disableButton(false);
        })
        .catch(err => {        
            if (err.response.status === 400) {
                alert('กรุณากรอกข้อมูลให้ครบถ้วน');
            } else if (err.response.status === 401) {
                alert('User authen invalid');
            } else if (err.response.status === 401) {
                alert(success_msg);
            } else {
                const { return_message } = err.response.data != null ? err.response.data : "";
                if (return_message != null) {
                    alert(return_message);
                } else {
                    alert('Internal error ' + err.response.status);
                }
            }
            this.disableButton(false);
        });
    }

    render() {
        const { disableSubmitButton, submitButtonText } = this.state
        return (
            <Button variant="primary" id={this.props.id} onClick={this.submitData} disabled={disableSubmitButton}>{submitButtonText}</Button>
        )
    }
}